import {hasLocalStorageFlag} from './localStorageFlags';

export const ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY = 'android_app_review_capability';

export const requestAndroidAppReview = () => {
  const androidBridge = (window as any).Android;

  if (androidBridge && typeof androidBridge.requestReview === 'function') {
    androidBridge.requestReview()
  } else if (hasLocalStorageFlag(ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY)) {
    console.info('Android app review requested via localStorage fallback');
  }
}

export const hasAndroidAppReviewCapability = (): boolean => {
  const androidBridge = (window as any).Android;

  return androidBridge && typeof androidBridge.requestReview === 'function' ||
    hasLocalStorageFlag(ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY);
}
